import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  name
  brandId
`

export const getAllScreenGroupsByBrandIdQuery = (brandId) => {
  return gql`
    query {
      getScreenGroupsByBrandId(brandId: "${brandId}") {
        ${common}
      }
    }
  `;
}

export const createScreenGroupMutation = (brandId, data) => {
  delete data.updateDate;
  var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate"], []);

  return gql`mutation {
      addScreenGroup(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const updateScreenGroupMutation = (brandId, data) => {
  delete data.updateDate;
  var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate"], []);

  return gql`mutation {
      updateScreenGroup(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const bulkDeleteScreenGroupMutation = (brandId, ids) => {
  var idsString = JSON.stringify(ids);

  return gql`
    mutation {
      bulkDeleteScreenGroup(brandId: "${brandId}", screenGroupIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const addScreenGroupToCache = async (brandId, datas) => {
  const query = getAllScreenGroupsByBrandIdQuery(brandId);
  const data = await executeQueryUtil(query);

  if (data) {
    await apolloClient.writeQuery({
      query: query,
      data: {
        getScreenGroupsByBrandId: [...data.data.getScreenGroupsByBrandId, ...datas]
      },
    });
  }
}

export const updateScreenGroupToCache = async (brandId, updated) => {
  const query = getAllScreenGroupsByBrandIdQuery(brandId);
  const data = await executeQueryUtil(query);

  if (data) {
    const newData = data.data.getScreenGroupsByBrandId.map(item =>
      item.id === updated.id ? {...item, ...updated} : item
    )
    await apolloClient.writeQuery({
      query: query,
      data: {
        getScreenGroupsByBrandId: [...newData]
      },
    });
  }
}

export const deleteScreenGroupFromCache = async (brandId, ids) => {
  const query = getAllScreenGroupsByBrandIdQuery(brandId);
  const res = await executeQueryUtil(query);
  const newData = res.data.getScreenGroupsByBrandId.filter(item =>
    !ids.includes(item.id)
  )

  if (res) {
    await apolloClient.writeQuery({
      query: query,
      data: {
        getScreenGroupsByBrandId: [...newData]
      },
    });
  }
}
